<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
        <template>
          <div v-if="departmentBalance" class="table-tip-text-class">
            {{businessDepartmentId?businessDepartmentName:'全部业务部'}}可用额度：<span class="amount-class">{{departmentBalance}}元</span>；
            </div>
        <wt-table :labels="tableLabels" ref="table" :list="tableData">
          <template>
            <el-table-column :label="hasMedicalReward?'医护人员姓名':'用户名'" width="110">
               <template scope="scope">
                <el-button v-if="scope.row.gainerName" @click="userDetail(scope.row)" type="text">{{scope.row.gainerName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column width="120" :label="hasMedicalReward?'医护人员手机号': '手机号'">
              <template scope="scope">
                {{scope.row.gainerMobile?scope.row.gainerMobile:"--"}}
              </template>
            </el-table-column>
            <el-table-column label="地区" width="120" v-if="hasMedicalReward">
              <template scope="scope">
                {{scope.row.extendInformation_addressDetails?scope.row.extendInformation_addressDetails:'--'}}
              </template>
            </el-table-column>
            <el-table-column label="所属医院" width="160" v-if="hasMedicalReward">
              <template scope="scope">
                {{scope.row.hospitalsName}}
              </template>
            </el-table-column>
            <el-table-column label="被邀用户姓名" width="120" v-if="hasMedicalReward">
              <template scope="scope">
                {{scope.row.triggerRewardUser_name}}
              </template>
            </el-table-column>
            <el-table-column label="母亲姓名" width="90" v-if="hasMedicalReward">
              <template scope="scope">
                {{scope.row.motherName}}
              </template>
            </el-table-column>
            <el-table-column label="预产期" width="160" v-if="hasMedicalReward">
              <template scope="scope">
                {{scope.row.expectedDateOfConfinement}}
              </template>
            </el-table-column>
            <el-table-column width="120" label="被邀用户手机号" v-if="hasMedicalReward">
              <template scope="scope">
                {{scope.row.triggerRewardUser_mobile}}
              </template>
            </el-table-column>
            <el-table-column label="是否业务员" v-if="!hasMedicalReward">
              <template scope="scope">
                {{scope.row.isSalesMan}}
              </template>
            </el-table-column>
            <el-table-column label="是否绑定CPS合同" v-if="!hasMedicalReward">
              <template scope="scope">
                {{scope.row.isCpsBind}}
              </template>
            </el-table-column>
            <el-table-column label="所属业务员姓名" v-if="!hasMedicalReward">
              <template scope="scope">
                {{scope.row.salesManName?scope.row.salesManName:"--"}}
              </template>
            </el-table-column>
            <el-table-column label="分享人" v-if="!hasMedicalReward">
              <template scope="scope">
                {{scope.row.sharingPersonName?scope.row.sharingPersonName:"--"}}
              </template>
            </el-table-column>
            <el-table-column label="分享人手机号" v-if="!hasMedicalReward">
              <template scope="scope">
                {{scope.row.sharingPersonMobile?scope.row.sharingPersonMobile:"--"}}
              </template>
            </el-table-column>
            <el-table-column label="商品名称" v-if="!hasMedicalReward">
              <template scope="scope">
                {{scope.row.goodsName?scope.row.goodsName:"--"}}
              </template>
            </el-table-column>
            <el-table-column label="返现金额">
              <template scope="scope">
                {{scope.row.reward_money?'¥'+scope.row.reward_money:"--"}}
              </template>
            </el-table-column>
            <el-table-column label="优惠券金额" v-if="!hasMedicalReward">
              <template scope="scope">
                {{scope.row.reward_coupon_total_amount?'¥'+scope.row.reward_coupon_total_amount:"--"}}
              </template>
            </el-table-column>
            <el-table-column label="奖励时间" min-width="160">
              <template scope="scope">
              {{scope.row.created_date}}
              </template>
            </el-table-column>
            <el-table-column label="客服审核备注" v-if="!hasMedicalReward">
              <template slot-scope="scope">
                <template v-if="scope.row.salesApprovalRemark">
                  <el-tooltip :content="scope.row.salesApprovalRemark" placement="bottom">
                  <div :class="$style['remark-div']">
                    {{scope.row.salesApprovalRemark}}
                  </div>
                  </el-tooltip>
                </template>
                <template v-else>--</template>
                </template>
            </el-table-column>
            <el-table-column label="财务审核备注" v-if="!hasMedicalReward">
              <template scope="scope">
                <template v-if="scope.row.treasurerApprovalRemark">
                   <el-tooltip :content="scope.row.treasurerApprovalRemark" placement="bottom">
                    <div :class="$style['remark-div']">
                      {{scope.row.treasurerApprovalRemark}}
                    </div>
                   </el-tooltip>
                </template>
                <template v-else>--</template>
                </template>
            </el-table-column>
            <el-table-column label="奖励状态" >
              <template scope="scope">
              {{scope.row.audit_status}}
              </template>
            </el-table-column>
          </template>
          <slot/>
        </wt-table>
        <div v-if="departmentBalance" class="table-tip-text-class">
            {{businessDepartmentId?businessDepartmentName:'全部业务部'}}可用额度：<span class="amount-class">{{departmentBalance}}元</span>；
            </div>
        </template>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
import { allAuditLables, medicalRewardLables } from '../all-audit'
const prefixCls = 'pt-all-audit-table'
export default {
  name: 'pt-all-audit-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    },
    businessDepartmentName () {
      let name
      this.departmentList.forEach(item => {
        if (item.id === this.businessDepartmentId) {
          name = item.name
        }
      })
      return name
    }
  },
  props: {
    totalNumber: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    tableData: {
      type: Array
    },
    departmentBalance: [Number, String],
    businessDepartmentId: String,
    departmentList: Array,
    hasMedicalReward: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOutside: false,
      tableLabels: this.$route.path === '/doctor-invite-reward' ? medicalRewardLables : allAuditLables
    }
  },
  methods: {
    userDetail (row) {
      this.$router.push('/all-customer/customer-detail/' + row.rewardObjectId + '?state=basic-message')
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getTableData', page, next, size)
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

.remark-div{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
